
import { Product, ProductGroup } from "@/types/product";
import { avoipProducts, getAVOIPProductsBySpeed } from "./avoip";
import { reaxProducts } from "./reax";
import { audioProducts } from "./audio";
import { meetingRoomProducts } from "./meeting";
import { hdbasetProducts } from "./hdbaset";
import { ipbasetProducts } from "./ipbaset";
import { convertersScalersProducts } from "./converters";
import { hdmiSwitchers } from "./switchers";
import { productGroups } from "./groups";

export { avoipProducts, getAVOIPProductsBySpeed } from "./avoip";
export { reaxProducts } from "./reax";
export { audioProducts } from "./audio";
export { meetingRoomProducts } from "./meeting";
export { hdbasetProducts } from "./hdbaset";
export { ipbasetProducts } from "./ipbaset";
export { convertersScalersProducts } from "./converters";
export { hdmiSwitchers } from "./switchers";
export { productGroups } from "./groups";

export const products: Product[] = [
  ...avoipProducts,
  ...reaxProducts,
  ...audioProducts,
  ...meetingRoomProducts,
  ...hdbasetProducts,
  ...ipbasetProducts,
  ...convertersScalersProducts,
  ...hdmiSwitchers
];

export const getProductsByGroup = (groupId: string): Product[] => {
  return products.filter((product) => product.groupId === groupId);
};

export const getProductBySlug = (slug: string): Product | undefined => {
  return products.find((product) => product.slug === slug);
};

export const getGroupBySlug = (slug: string): ProductGroup | undefined => {
  return productGroups.find((group) => group.slug === slug);
};
